import SiteHeader from '../components/SiteHeader.jsx'

export default function SiteShell({ children }) {
  return (
    <>
      <SiteHeader />
      {children}
    </>
  )
}
